import React from "react";
import { useTrans } from "system/translations/hooks";
import {
  useGetRejectionReasons
} from "modules/rejectionReasons/apiHooks";
import SectionTitle from "components/atoms/SectionTitle";
import globalStyles from "system/theme/globalStyles";
import { generatePath, useHistory } from "react-router-dom";
import { APP_ROUTES } from "system/router/constants";
import { EditIcon, PlusIcon, TrashIcon } from "evergreen-ui";
import ButtonLink from "components/atoms/ButtonLink";
import { useTableColumns } from "./constantHooks";
import Table from "services/table";
import { useDeleteRejectionReasonHelper } from "./hooks";

const RejectionReasons = () => {
  const history = useHistory();
  const { _t } = useTrans();
  const columns = useTableColumns();
  const { onDeleteWithConfirm } = useDeleteRejectionReasonHelper(_t);
  const { data = [], isLoading } = useGetRejectionReasons();
  const onUpdate = ({ id }: any) => {
    const link = generatePath(APP_ROUTES.rejectionReasons.update, { id });
    history.push(link, history.location);
  };

  const actionMenuItems = [
    { title: _t("edit"), onClick: onUpdate, icon: <EditIcon size={12} /> },
    {
      title: _t("delete"),
      onClick: onDeleteWithConfirm,
      icon: <TrashIcon size={12} />,
      intent: "danger",
    },
  ];

  return (
    <>
      <div css={globalStyles.mobileHeader}>
        <SectionTitle
          title={_t("rejection_reasons")}
          extra={
            <ButtonLink
              kind={"secondary"}
              iconBefore={PlusIcon}
              linkTo={APP_ROUTES.rejectionReasons.create}
              label={_t("create_rejection_reason")}
            />
          }
        />
      </div>

      <Table
        columns={columns}
        data={data}
        isLoading={isLoading}
        cellProps={{ actionMenuItems }}
        isPagination
        totalRecords={data?.length}
        showSettingsIcon={false}
      />
    </>
  );
};

export default RejectionReasons;
